import { Box } from "@mui/material";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import {
  ModalContainerStyled,
  ModalContentStyled,
  ModalFooterStyled,
  ModalHeaderStyled,
  MuiButton,
} from "@ryde/controls";
import {
  IDialogContainerProps,
  SimpleResult,
  simpleResultFalse,
  simpleResultTrue,
} from "@ryde/shared";

const MODAL_WIDTH = "530px";

interface IDialogRideConfirmProps {
  title: string;
  message: string | ReactNode;
  resolveFn: (result: SimpleResult<unknown>) => void;
  okButtonLabel?: string;
  cancelButtonLabel?: string;
}

export const DialogRideConfirm: FC<
  IDialogRideConfirmProps & IDialogContainerProps
> = ({
  title,
  message,
  resolveFn,
  onClose,
  okButtonLabel,
  cancelButtonLabel,
}) => {
  const { t } = useTranslation();

  const onCancel = (): void => {
    resolveFn(simpleResultFalse);
    onClose();
  };

  const onAccept = (): void => {
    resolveFn(simpleResultTrue);
    onClose();
  };

  return (
    <ModalContainerStyled width={MODAL_WIDTH}>
      <ModalHeaderStyled>
        <h1>{title}</h1>
        <SVG_MUI.XMarkSVG onClick={onCancel} />
      </ModalHeaderStyled>
      <ModalContentStyled>
        <Box sx={{ pt: 1, pb: 1 }}>{message}</Box>
      </ModalContentStyled>
      <ModalFooterStyled>
        <MuiButton
          muiStyle={"primary"}
          muiVariant={"outlined"}
          onClick={onCancel}
          e2eData="cancel-modal-button"
        >
          {cancelButtonLabel ?? t(`general.CANCEL`)}
        </MuiButton>
        <MuiButton
          muiVariant={"outlined"}
          muiStyle={"warning"}
          onClick={onAccept}
          e2eData="accept-data-change"
        >
          {okButtonLabel ?? t(`general.ACCEPT`)}
        </MuiButton>
      </ModalFooterStyled>
    </ModalContainerStyled>
  );
};
